import { theme } from '../../app/Theme'

export const styles = {
  container: { padding: theme.spacing(4) },
  form: { width: '100%', maxWidth: '658px', marginTop: theme.spacing(6) }
}
